// Navigation scripts
const mobilemenu = {
    addEvents: function () {
        //Menu Toggle
        var mobiletoggle = document.getElementById('burger-menu');
        var mobilemenu = document.getElementById('mob-menu');
        mobiletoggle.onclick = function (e) {
            e.target.classList.toggle('open');
            mobilemenu.classList.toggle('open');
            document.body.classList.toggle('modal-open');
        };

        //Mobile Submenu
        var hassubmenu = document.querySelectorAll("#mob-menu .has-megamenu > a ");
        for (var i = 0; i < hassubmenu.length; i++) {
            hassubmenu[i].onclick = function (e) {
                e.preventDefault();

                var el = e.target;
                var showmenu = el.nextElementSibling;
                if (showmenu) {
                    //el.classList.toggle('open');
                    showmenu.classList.toggle('open');
                    el.classList.toggle('open');
                }

            };
        }

        //Mobile Submenu Close
        var backbuttons = document.querySelectorAll(".submenu-actions__back");
        for (var i = 0; i < backbuttons.length; i++) {
            backbuttons[i].onclick = function (e) {
                e.preventDefault();
                var megamanus = document.querySelectorAll(".mega-nav.open");
                for (var x = 0; x < megamanus.length; x++) {
                    megamanus[x].classList.remove('open');
                }

            };
        }

        //Submenu Accordions
        var submenutitles = document.querySelectorAll('.mega-nav__title');
        for (var i = 0; i < submenutitles.length; i++) {
            submenutitles[i].onclick = function (e) {
                var el = e.target;
                el.classList.toggle('open');

                if (el.nextElementSibling) {
                    el.nextElementSibling.classList.toggle('open');
                }
            }
        }

        var submenuchilden = document.querySelectorAll(".menu-item-has-children");
        for (var i = 0; i < submenuchilden.length; i++) {
            submenuchilden[i].onclick = function (e) {
                var el = e.target;
                el.classList.toggle('open');

                if (el.nextElementSibling) {
                    el.nextElementSibling.classList.toggle('open');
                }
            }
        }

    }

}

export default mobilemenu;